import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import ReportView from "@/components/ReportView";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function Report() {
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [notReady, setNotReady] = useState(false);

  useEffect(() => {
    api.get("/student/report").then((res) => setReport(res.data)).catch(() => setNotReady(true));
  }, []);

  if (notReady || (report && report.status !== "READY")) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400 text-center px-6" data-testid="report-not-ready">
        Your report is still being prepared. Please check back shortly.
      </div>
    );
  }
  if (!report) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading your report…</div>;

  return (
    <div className="min-h-screen bg-slate-50 px-6 py-12" data-testid="student-report-page">
      <div className="max-w-5xl mx-auto mb-6">
        <Button variant="ghost" data-testid="report-back-button" onClick={() => navigate("/dashboard")} className="text-slate-500">
          <ArrowLeft className="h-4 w-4 mr-2" /> Back to Dashboard
        </Button>
      </div>
      <ReportView report={report} isDemo={false} translateUrl="/student/report/translate" />
    </div>
  );
}
